import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';
import { FloorArea } from './floorarea';

import { QrCode } from './qrcode';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { FloorAreaType } from '../types';

const _schema = {
    "name": "DRAWITEM",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "type", type: "string" },
        { name: "area", type: "objid" },
        { name: "shape", type: "string" },
        { name: "custom", type: "string" },
        { name: "sort", type: "number", default: "0" },
        { name: "coord_x", type: "number" },
        { name: "coord_y", type: "number" },
        { name: "coord_w", type: "number" },
        { name: "coord_h", type: "number" },
        { name: "coord_r", type: "number" },
    ],
    relate: [
        { direction: ">", target: "FLOORAREA", by: "area", name: "area", reason: "area", child: false, class: FloorAreaType },
    ],
} as const;

const _DrawItemClass = CreateObject(_schema);
if (!_DrawItemClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class DrawItem extends _DrawItemClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null) {
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): DrawItem {
        return this._Copy(store) as DrawItem;
    }

    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'area' && related instanceof FloorArea){
            if (related === this.area){
                related.AddDraw(this);
            }
        }
    }

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string) {
        if (this.status == 'DE') {
            return;
        }

        if (this.status == value) {
            return;
        }

        this['__base__status'] = value;
        const parent = this.area as DataObject | null;
        if (parent) {
            parent.DoRefresh(this.table);
        }
    }

    get IsValid(): boolean {
        return !!this.status && this.status != 'DE';
    }

    /** Valid QRCODE rows linked to this draw item (derived from `QRCODE.draw`). */
    get qrcodes(): QrCode[] {
        const _area = this.area;
        const _place = _area?.place;
        if (!_place){
            return [];
        }

        const _qrcodes: QrCode[] = [];
        for (const _qrcode of _place.qrcodes ?? []){
            if (_qrcode.IsValid && _qrcode.draw === this){
                _qrcodes.push(_qrcode);
            }
        }

        return _qrcodes;
    }

    get qrcode(): QrCode | null {
        for (const _qrcode of this.qrcodes) {
            if ((_qrcode.draw === this) && _qrcode.IsValid) {
                return _qrcode;
            }
        }
        
        return null;
    }

    /***************************************/
    /* Keep UppKonvaShape Reference        */
    /***************************************/

    private _konvaRef: WeakRef<any> | null = null;

    get konva(): any | null {
        return this._konvaRef?.deref() ?? null;
    }

    set konva(value: any | null) {
        this._konvaRef = value ? new WeakRef(value) : null;
    }
}
